import { TENANT_CH } from 'shared/consts'
import { event as e } from 'shared/experiments/utils/event'

// TODO add TENANT_AT when WSBEARS-1119 is fixed
export const REDIRECTION_TENANTS = [TENANT_CH]

export const EVENT_TRIGGERED = e`CUSTOMER REDIRECT - triggered`
export const EVENT_NO_REDIRECTION = e`CUSTOMER REDIRECT - no redirection`
export const EVENT_AT_REDIRECTION = e`CUSTOMER REDIRECT - AT redirection`
export const EVENT_CH_REDIRECTION = e`CUSTOMER REDIRECT - CH redirection`
